import ChevronRight from "../../../assets/svgs/ChevronRight.svg";
import { useAxios } from "../../../hooks";
import TickIcon from "../../../assets/images/tick1.svg"

export default function TaskItem(props) {
  const { axiosInstance } = useAxios();
  const handleMarkComplete = (actionItemId) => {
    props.completeItem(actionItemId);
    axiosInstance.post("/action-item/complete", { itemId: actionItemId }).then((res) => {
      if (res.data) {
      }
    }).catch((error) => {
      console.log(error)
    });
  };

  const fixLinksInHtml = (html) => {
    return html.replace(/href="(?!https?:\/\/)([^"]+)"/g, 'href="https://$1"');
  };

  const sanitizedDescription = fixLinksInHtml(props["Description"]);

  const hasValidUrl = props["URL"] && props["URL"].trim() !== "";
  
  return (
    <div className={`border border-lightGrey rounded-[12px] mb-2 ${props["Completed"] ? "bg-[#F0FDF4]" : ""}`}>
      {hasValidUrl ? (
        <a 
          href={props["URL"].startsWith('http') ? props["URL"] : `https://${props["URL"]}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="block p-3 pb-1 group"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <div className="flex flex-row items-center">
            <div className="flex-1">
              <div className="text-sm font-medium text-titleColor group-hover:underline transition-all duration-200" dangerouslySetInnerHTML={{ __html: props["Title"] }}></div>
              <div className="text-xs text-titleColor overflow-hidden text-ellipsis whitespace-pre-wrap truncate" dangerouslySetInnerHTML={{ __html: sanitizedDescription }}>
              </div>
              <div className="text-xs text-[#1F2937] truncate italic">
                <a href={props["URL"].startsWith('http') ? props["URL"] : `https://${props["URL"]}`}  target="_blank" rel="noopener noreferrer">
                  {props["URL"].substring(0, 50) + (props["URL"].length > 50 ? "..." : "")}
                </a>
              </div>
              <div className="text-xs text-[#6B7280]">Posted {new Date(props["CreatedAt"]).toLocaleDateString()}</div>
            </div>
            {!props["Completed"] && (
              <div>
                <img src={ChevronRight} alt="" />
              </div>
            )}
          </div>
        </a>
      ) : (
        <div className="block p-3 pb-1">
          <div className="flex flex-row items-center">
            <div className="flex-1">
              <div className="text-sm font-medium text-titleColor" dangerouslySetInnerHTML={{ __html: props["Title"] }}></div>
              <div className="text-xs text-titleColor overflow-hidden text-ellipsis whitespace-pre-wrap truncate" dangerouslySetInnerHTML={{ __html: sanitizedDescription }}>
              </div>
              <div className="text-xs text-[#6B7280]">Posted {new Date(props["CreatedAt"]).toLocaleDateString()}</div>
            </div>
          </div>
        </div>
      )}
      {!props["Automatic_Completion"] && !props["Completed"] ? (
        <div className={`pt-1 pb-2 pl-[12px]`}>
          <button class="
            flex items-center gap-2
            bg-transparent border border-teal text-teal
            hover:bg-teal hover:bg-opacity-10
            text-center px-2 py-1 rounded-md 
            transition-all duration-200 text-xs md:text-sm
          "
          onClick={() => handleMarkComplete(props["Action_Item_ID"])}>
            <span>Mark as complete</span>
            <img className="w-4 h-4" src={TickIcon} alt="Mark as complete" />
          </button>
        </div>
      ) : null}
    </div>
  );
}
